export function convertBackwardCompatiblePropsToStyle(props){return{width:props.width,height:props.height,backgroundColor:props.bgColor};}